import Alpine from 'alpinejs'
import {
  addSave as addSaveToDB,
  getUserSaves,
  removeSave as removeSaveFromDB,
  STORAGE_KEY,
} from '@/utils/simple-save-helpers'
import { getVerifiedUserId } from '@/utils/get-verified-user-id'
export interface SaveItem {
  userId: string
  itemId: string
  type: 'product' | 'recipe'
}

Alpine.data('saveButton', (id: string, type: SaveItem['type']) => ({
  id,
  type,
  isSaved: false,
  init() {
    this.initSaveState()
  },
  initSaveState() {
    const saves = getUserSaves()
    if (saves) {
      this.isSaved = !!saves.get(this.id)
    }
  },
  async toggleSaved() {
    const hasSavesStorage = !!localStorage.getItem(STORAGE_KEY)
    const verifiedUserId = await getVerifiedUserId()

    if (verifiedUserId && hasSavesStorage) {
      this.isSaved
        ? this.$dispatch('onRemoveSave', {
            userId: verifiedUserId,
            itemId: this.id,
            type: this.type,
          })
        : this.$dispatch('onAddSave', { userId: verifiedUserId, itemId: this.id, type: this.type })
    } else {
      this.$dispatch('open-auth-menu', {
        context: 'saveButton',
        metadata: { saveItem: { id: this.id, type: this.type } },
      })
    }
  },
  addSave({ userId, itemId, type }: SaveItem) {
    if (this.id !== itemId || this.isSaved) return
    this.isSaved = true
    addSaveToDB(userId, itemId, type).catch(() => {
      this.isSaved = false
    })
  },
  removeSave({ userId, itemId, type }: SaveItem) {
    if (this.id !== itemId || !this.isSaved) return
    this.isSaved = false
    removeSaveFromDB(userId, itemId, type).catch(() => {
      this.isSaved = true
    })
  },
  eventHandlers: {
    [`@onAddSave.window`]({ detail }: { detail: SaveItem }) {
      this.addSave(detail)
    },
    [`@onRemoveSave.window`]({ detail }: { detail: SaveItem }) {
      this.removeSave(detail)
    },
    [`@initSaveBtnsState.window`]() {
      this.initSaveState()
    },
  },
}))
